import { renderHtmlToReact } from '@src/utils/html';
import { Themed } from '@theme-ui/mdx';
import { Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import { Box, Button, Container, Grid } from 'theme-ui';

const CtaBanner = ({
  variant,
  title,
  description,
  buttonText,
  buttonLink,
  image,
  splitVerticalBgColor,
}) => {
  let variantButton = 'primary';
  let isPrimary = false;

  if (variant === 'primary') {
    isPrimary = true;
  }

  return (
    <Box
      className="relative"
      py={[5, isPrimary ? 6 : 3]}
      sx={{
        paddingLeft: isPrimary ? '' : 4,
        paddingRight: isPrimary ? '' : 4,
      }}
    >
      <Box
        bg={splitVerticalBgColor}
        sx={{
          position: 'absolute',
          top: 0,
          bottom: '50%',
          left: 0,
          right: 0,
          zIndex: '-1',
        }}
      />
      <Container
        px={4}
        sx={{
          position: isPrimary ? 'static' : 'relative',
          overflow: isPrimary ? '' : 'hidden',
          transform: isPrimary ? '' : 'translateZ(0)',
          borderRadius: isPrimary ? '' : '40px',
        }}
      >
        <Box
          bg="primaryPale"
          sx={{
            position: 'absolute',
            height: '100%',
            width: ['100%', '50%'],
            left: 0,
            top: 0,
            zIndex: '-1',
          }}
        />

        <Grid
          className="relative"
          gap="50px"
          columns={image ? [1, 2, 2] : [1]}
          sx={{ alignItems: 'center' }}
        >
          <Box
            sx={{
              maxWidth: '600px',
              textAlign: image ? 'left' : 'center',
              padding: isPrimary ? '' : ['32px 0 0', '60px 32px', '120px 32px'],
            }}
          >
            {title && (
              <Themed.h2 sx={{ marginTop: '0', lineHeight: '1.2' }}>
                {title}
              </Themed.h2>
            )}
            {description && <Box my={4}>{renderHtmlToReact(description)}</Box>}

            {buttonText && buttonLink && (
              <Link to={`/${buttonLink}`}>
                <Button variant={variantButton}>{buttonText}</Button>
              </Link>
            )}
          </Box>
        </Grid>

        {image && (
          <Box
            sx={{
              position: ['static', 'absolute'],
              height: ['auto', '100%'],
              width: ['100%', '50%'],
              right: 0,
              top: 0,
              borderRadius: ['20px', '0'],
              overflow: 'hidden',
              zIndex: '-1',
              transform: 'translateZ(0)',
              marginTop: [4, 0],
              marginBottom: [!isPrimary ? 4 : 0, 4],
            }}
          >
            <GatsbyImage
              sx={{ width: '100%', height: '100%' }}
              image={getImage(image)}
              alt=""
            />
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default CtaBanner;
